// Deterministic 50/50 client-side A/B assignment. Stable per user (same userId => same arm).
export type DunningArm = 'control' | 'modal';

export function assignDunningArm(userId: string | undefined | null): DunningArm {
  if (!userId) return 'control';                 // fail to the current behavior
  const key = `${userId}:dunning_cta_2026q3`;
  let h = 5381;                                   // djb2
  for (let i = 0; i < key.length; i++) h = ((h << 5) + h + key.charCodeAt(i)) >>> 0;
  return (h % 100) < 50 ? 'control' : 'modal';
}
